export interface Callback {
  name: string;
  fn: () => Promise<void> | void;
}

export enum CallbackNames {
  SyncFormData = 'SyncFormData',
  SyncTimeData = 'SyncTimeData',
  SyncAllData = 'SyncAllData',
  EmitChangeForTimeRecord = 'EmitChangeForTimeRecord',
  EmitChangeForActivityLog = 'EmitChangeForActivityLog',
  EmitChangeForActivity = 'EmitChangeForActivity',
  EmitChangeForNotableActivity = 'EmitChangeForNotableActivity',
  EmitChangeForProject = 'EmitChangeForProject',
  EmitChangeForProjectGIS = 'EmitChangeForProjectGIS',
  EmitChangeForStatusLookup = 'EmitChangeForStatusLookup',
  EmitChangeForAttachment = 'EmitChangeForAttachment',
  EmitChangeForLaborCategory = 'EmitChangeForLaborCategory',
  EmitChangeForTask = 'EmitchangeForTask',
  EmitChangeForFieldActivity = 'EmitChangeForFieldActivity',
  EmitChangeForTeamUser = 'EmitChangeForTeamUser',
  EmitChangeForTimeManagerProject = 'EmitChangeForTimeManagerProject',
  EmitChangeForTimeManagerTeam = 'EmitChangeForTimeManagerTeam',
  EmitChangeForEntityType = 'EmitChangeForEntityType',
  EmitChangeForFIPSState = 'EmitChangeForFIPSState',
  EmitChangeForTimeRecordStatus = 'EmitChangeForTimeRecordStatus',
  EmitchangeForUser = 'EmitChangeForUser',
  EmitChangeForUserFieldActivity = 'EmitChangeForUserFieldActivity',
  EmitChangeForUserProject = 'EmitChangeForUserProject',
  EmitChangeForOdometerReading = 'EmitChangeForOdometerReading',
  ScheduleActivityReminder = 'ScheduleActivityReminder',
  ValidateTimeRecord = 'ValidateTimeRecord',
  ValidateActivityLog = 'ValidateActivityLog',
  ValidateActivity = 'ValidateActivity',
  ValidateOdometerReading = 'ValidateOdometerReading',
}

export enum CallbackAddMode {
  RemoveDuplicatesAndPush,
  PushIfNotDuplicate,
  PushDuplicate,
}
